import { GoLocation } from "react-icons/go";
import styled from "styled-components";

const Container = styled.div`
  /* display: flex;
  justify-content: center;
  align-items: center; */
  font-size: 30px;
`;

const LocationPin = ({ text }) => (
  <Container className="pin">
    <GoLocation />
    {/* <p className="pin-text">{text}</p> */}
  </Container>
);

export default LocationPin;
